module.exports = __webpack_public_path__ + "img/step3.904b1546.png";